/**
 * The pre-order logic looks like this:
 * 
 * If variant sold out and there is an incoming transfer
 * Show the date of the incoming transfer
 * code in snippets/add-to-cart and theme.css
 * tagged pre-order
 */
(function() {
  document.addEventListener('variant:changed', function(event) {
var firstNumber = document.getElementById('myval').textContent;
     
alert(firstNumber);

    
    var variant = event.detail.variant;
    var container = event.target;

    var incomingJSON = container.querySelector('[data-incoming]');
    if (variant) {
      var incomingArray = null;
      if (typeof incomingJSON !== 'undefined') {
        incomingArray = JSON.parse(incomingJSON.innerText);
      }
      var arr = incomingArray.variants;
      for (let index = 0; index < arr.length; index++) {
        var loopVariant = arr[index];
        if (variant.id.toString() === loopVariant.id) {
          variant.incoming = loopVariant.incoming;
          variant.next_incoming_date = loopVariant.next_incoming_date;
        }
      }
      if (!variant.available && variant.incoming) {
        // For true pre-order you will want variant.avialable set to true
        var date = new Date(variant.next_incoming_date);
        var month = date.toLocaleString('default', { month: 'long' });
        var day = date.getDate();
        var dateString = '<p class="ProductForm__Inventory Text--subdued">Order now, aviablable on ' + month + ' ' + day + '</p>';
        // show the incoming date
        container.querySelector('[data-incoming-date]').innerHTML = dateString;
      } else {
        // wipe the incoming date
        container.querySelector('[data-incoming-date]').innerHTML = '';
      }
    }
    var isEmbassingSelected = document.getElementById("8282032144658-variants-Size-XS").selectedIndex == 1;

if (isEmbassingSelected == false) {
  // hide embossing
  document.getElementsByClassName("rts")[0].style.display = "none";
}
  });


 document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    if (variant) {
        var priceProduct = variant.price; // Price is in cents
        var threePercent = Math.round(priceProduct * 0.03 / 100); // Calculate 4% and convert to dollars

        // Select the span and update it
        var discountSpan = document.querySelector('#three-percent-amount');
        if (discountSpan) {
            discountSpan.textContent = threePercent; // Set as a whole number
        }
    }
});

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator

      var pricecart = cart.total_price; // Price is in cents
        var threePercentCart = Math.round(pricecart * 0.03 / 100); // Calculate 4% and convert to dollars

        // Select the span and update it
        var discountCartSpan = document.querySelector('#cart-amount-three');
        if (discountCartSpan) {
            discountCartSpan.textContent = threePercentCart; // Set as a whole number
        }
    }
  });

})();

(function() {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function getOptionName(option) {
    return option && typeof option === 'object' ? option.name : option;
  }

  function selectLowestPriceVariant() {
    if (!document.body.classList.contains('template-product')) return;
    if (new URLSearchParams(window.location.search).has('variant')) return;

    var productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (error) {
      return;
    }

    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return;

    var lowestVariant = product.variants.reduce(function(lowest, variant) {
      return Number(variant.price) < Number(lowest.price) ? variant : lowest;
    }, product.variants[0]);

    if (!lowestVariant || !Array.isArray(lowestVariant.options)) return;

    var form = document.querySelector('[data-product-form]');
    var changed = false;

    lowestVariant.options.forEach(function(value, index) {
      var optionName = getOptionName(product.options[index]);
      if (!optionName) return;

      var optionInputs = Array.prototype.slice.call(document.querySelectorAll('[name="options[' + optionName.replace(/"/g, '\\"') + ']"]'));
      var matchingInput = optionInputs.find(function(input) {
        return input.value === value;
      });

      if (matchingInput && (matchingInput.type === 'radio' || matchingInput.type === 'checkbox')) {
        if (!matchingInput.checked) {
          matchingInput.checked = true;
          matchingInput.dispatchEvent(new Event('change', {bubbles: true}));
          changed = true;
        }
      } else if (matchingInput && matchingInput.value !== value) {
        matchingInput.value = value;
        matchingInput.dispatchEvent(new Event('change', {bubbles: true}));
        changed = true;
      }
    });

    var variantInputs = Array.prototype.slice.call(document.querySelectorAll('[name="id"], #selected-variant-id, #dynamic-variant-id'));
    variantInputs.forEach(function(input) {
      if (input && input.value !== String(lowestVariant.id)) {
        input.value = lowestVariant.id;
        input.dispatchEvent(new Event('change', {bubbles: true}));
      }
    });

    if (!changed && form) {
      form.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }

  onReady(function() {
    window.setTimeout(selectLowestPriceVariant, 0);
  });
})();
